import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '360px',
    minWidth: '360px',
    height: '100%',
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    borderLeft: `1px solid ${capitalDesignTokens.semanticColors.border.primary}`,
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    borderBottom: `1px solid ${capitalDesignTokens.semanticColors.border.primary}`
  },
  headerTitle: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
    padding: '8px 0'
  },
  switchControlLabel: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: '0px',
    margin: '0px',
    marginBottom: '16px',
    '& input': {
      display: 'none'
    }
  },
  pdfScaleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    marginTop: '16px'
  },
  pdfScaleLabel: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    lineHeight: '20px'
  }
});
